export const DIGITAL_ASSETS_REQUEST = 'DIGITAL_ASSETS_REQUEST';
export const DIGITAL_ASSETS_SUCCESS = 'DIGITAL_ASSETS_SUCCESS';
export const DIGITAL_ASSETS_FAILURE = 'DIGITAL_ASSETS_FAILURE';
export const HEADER_LINKS_REQUEST = 'HEADER_LINKS_REQUEST';
export const HEADER_LINKS_SUCCESS = 'HEADER_LINKS_SUCCESS';
export const HEADER_LINKS_FAILURE = 'HEADER_LINKS_FAILURE';
export const ECXLUSIVE_UPDATES_REQUEST = 'ECXLUSIVE_UPDATES_REQUEST';
export const ECXLUSIVE_UPDATES_SUCCESS = 'ECXLUSIVE_UPDATES_SUCCESS';
export const ECXLUSIVE_UPDATES_FAILURE = 'ECXLUSIVE_UPDATES_FAILURE';
export const PRODUCT_INFO_REQUEST = 'PRODUCT_INFO_REQUEST';
export const PRODUCT_INFO_SUCCESS = 'PRODUCT_INFO_SUCCESS';
export const PRODUCT_INFO_FAILURE = 'PRODUCT_INFO_FAILURE';
export const PRODUCT_INFO_UPDATE_REQUEST = 'PRODUCT_INFO_UPDATE_REQUEST';
export const PRODUCT_INFO_UPDATE_SUCCESS = 'PRODUCT_INFO_UPDATE_SUCCESS';
export const PRODUCT_INFO_UPDATE_FAILURE = 'PRODUCT_INFO_UPDATE_FAILURE';
export const ALL_DETAILS_REQUEST = 'ALL_DETAILS_REQUEST';
export const ALL_DETAILS_SUCCESS = 'ALL_DETAILS_SUCCESS';
export const ALL_DETAILS_FAILURE = 'ALL_DETAILS_FAILURE';
export const GET_NPS_FEEDBACK_REQUEST = 'GET_NPS_FEEDBACK_REQUEST';
export const GET_NPS_FEEDBACK_SUCCESS = 'GET_NPS_FEEDBACK_SUCCESS';
export const GET_NPS_FEEDBACK_FAILURE = 'GET_NPS_FEEDBACK_FAILURE';
export const GET_NPS_RATING_REQUEST = 'GET_NPS_RATING_REQUEST';
export const GET_NPS_RATING_SUCCESS = 'GET_NPS_RATING_SUCCESS';
export const GET_NPS_RATING_FAILURE = 'GET_NPS_RATING_FAILURE';
export const GET_DASHBOARD_STATS_REQUEST = 'GET_DASHBOARD_STATS_REQUEST';
export const GET_DASHBOARD_STATS_SUCCESS = 'GET_DASHBOARD_STATS_SUCCESS';
export const GET_DASHBOARD_STATS_FAILURE = 'GET_DASHBOARD_STATS_FAILURE';
export const PRODUCT_SIGNUP_REQUEST = 'PRODUCT_SIGNUP_REQUEST';
export const PRODUCT_SIGNUP_SUCCESS = 'PRODUCT_SIGNUP_SUCCESS';
export const PRODUCT_SIGNUP_FAILURE = 'PRODUCT_SIGNUP_FAILURE';

export const GET_SE_URL_REQUEST = 'GET_SE_URL_REQUEST';
export const GET_SE_URL_SUCCESS = 'GET_SE_URL_SUCCESS';
export const GET_SE_URL_FAILURE = 'GET_SE_URL_FAILURE';
export const UPDATE_SE_URL_REQUEST = 'UPDATE_SE_URL_REQUEST';
export const UPDATE_SE_URL_SUCCESS = 'UPDATE_SE_URL_SUCCESS';
export const UPDATE_SE_URL_FAILURE = 'UPDATE_SE_URL_FAILURE';

export const SET_DIGITAL_IMAGE_PREVIEW = 'SET_DIGITAL_IMAGE_PREVIEW';
